import React, { useEffect } from "react";

const Testimonials = () => {
  useEffect(() => {
    // Initialize testimonials carousel after component mounts
    if (window.jQuery && window.jQuery().owlCarousel) {
      window.jQuery('#unique-testimonials').owlCarousel({
        loop: true,
        center: true,
        items: 3,
        margin: 0,
        autoplay: true,
        dots: true,
        autoplayTimeout: 8500,
        smartSpeed: 450,
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 2
          },
          1170: {
            items: 3
          }
        }
      });
    }

    // Initialize clients carousel
    if (window.jQuery && window.jQuery().owlCarousel) {
      window.jQuery('.clients-slider').owlCarousel({
        loop: true,
        autoplay: true,
        autoplayTimeout: 4500,
        autoplayHoverPause: true,
        items: 5,
        margin: 30,
        nav: false,
        dots: false,
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 3
          },
          1170: {
            items: 5
          }
        }
      });
    }
  }, []);

  return (
    <div>
      {/* Breadcrumbs */}
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>What My Clients Say?</h2>
                <ul className="bread-list">
                  <li><a href="/">Home</a></li>
                  <li><i className="icofont-simple-right"></i></li>
                  <li className="active">Testimonials</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Breadcrumbs */}

      {/* Start Testimonials */}
      <section className="testimonials">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div id="unique-testimonials" className="owl-carousel">
                {/* TESTIMONIAL 1 */}
                <div className="item">
                  <div className="shadow-effect">
                    <p>"Charlotte is very nice and amazing to work with. Knowledgeable in financial service and planning. Caring and easy to work with ☑️👍🏼👍🏼"</p>
                  </div>
                  <div className="testimonial-name">
                    Angelo C.
                    <p style={{ color: "whitesmoke" }}>CEO & Founder iGoWebSolution.Com</p>
                  </div>
                </div>
                {/* END OF TESTIMONIAL 1 */}
                {/* TESTIMONIAL 2 */}
                <div className="item">
                  <div className="shadow-effect">
                    <p>"Charlotte Enriquez is an amazing senior broker with many years of experience. She’ll help your business succeed through her company’s financial platform system that’ll train you and your staff on how to improve your marketing, sales, and personable skills! She can also help you with estate planning."</p>
                  </div>
                  <div className="testimonial-name">
                    Wassim Yassine
                    <p style={{ color: "whitesmoke" }}>A-Z Driving School - Owner</p>
                  </div>
                </div>
                {/* END OF TESTIMONIAL 2 */}
                {/* TESTIMONIAL 3 */}
                <div className="item">
                  <div className="shadow-effect">
                    <p>"It’s been great knowing Charlotte for many years, she is very professional and has high standards. She has personally helped and given me great advice for my business and personal finances. I highly recommend her. She has great leadership and financial skills."</p>
                  </div>
                  <div className="testimonial-name">
                    Jose
                    <p style={{ color: "whitesmoke" }}>Organic Services Inc.</p>
                  </div>
                </div>
                {/* END OF TESTIMONIAL 3 */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End Testimonials */}

      {/* Clients Section */}
      <div className="clients overlay">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="owl-carousel clients-slider">
                <div className="single-clients">
                  <img src="img/client1.png" alt="Client 1" />
                </div>
                <div className="single-clients">
                  <img src="img/client2.png" alt="Client 2" />
                </div>
                <div className="single-clients">
                  <img src="img/client3.png" alt="Client 3" />
                </div>
                <div className="single-clients">
                  <img src="img/client4.png" alt="Client 4" />
                </div>
                <div className="single-clients">
                  <img src="img/client5.png" alt="Client 5" />
                </div>
                <div className="single-clients">
                  <img src="img/client6.png" alt="Client 6" />
                </div>
                <div className="single-clients">
                  <img src="img/client7.png" alt="Client 7" />
                </div>
                <div className="single-clients">
                  <img src="img/client8.png" alt="Client 8" />
                </div>
                <div className="single-clients">
                  <img src="img/client9.png" alt="Client 9" />
                </div>
                <div className="single-clients">
                  <img src="img/client11.png" alt="Client 11" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Clients Section */}
    </div>
  );
};

export default Testimonials;
